import SimpleAccordion from '../components/SimpleAccordion';

export const DetailListView = ({ list = [] }) => {

  if (list.length < 1) {
    return (<></>);
  }

  const serializedList = list.map((item) => ({ title: item.title, icon: item.icon, content: item?.hotelInformationDetailLabel[0].description }));

  return (
    <>
      <SimpleAccordion items={serializedList} />
    </>
  );
};
